<template>
  <v-layout class="bloque">
    <v-flex xs3 class="text-center colorHeaders" align-center align="center">{{
      alumno.nombre
    }}</v-flex>
    <template v-for="(materia, index_mat) in alumno.materias">
      <v-flex xs2 :key="index_mat">
        <template v-for="(nota, index_nota) in materia.notas">
          <v-flex class="elevation-3 item" align-center shrink :key="index_nota"
            >{{ nota.periodo }}: {{ formato_numero(nota.nota) }}</v-flex
          >
        </template>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["alumno"],
  mounted: function () {
    //console.log(this.alumno);
  },
  methods: {
    formato_numero: function (numero) {
      /*console.log(
        "formato_numero",
        numero,
        !isNaN(numero),
        !isNaN(numero) && numero <= 10
      );*/
      if (!isNaN(numero) && numero <= 10) {
        //console.log("if");
        if (numero == 0) {
          numero = "AUS";
        } else {
          numero = parseFloat(numero).toFixed(2);
        }
        //console.log(numero, !isNaN(numero));
        return numero;
      } else {
        console.log("else formato_numero");
        return "";
      }
    },
  },
};
</script>

<style scoped>
.colorHeaders {
  color: #fff;
  font-weight: bold;
  background-color: #4caf50;
  opacity: 0.7;
  margin: 2px;
}

.bloque {
  padding-bottom: 7px;
  /*background: #ddd;*/
}

.item {
  background: #ddd;
  margin: 3px;
}
</style>